'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Anatomy } from './ContextMenu.anatomy';
export const ContextMenu = ({ children, ...props }) => {
    return _jsx(Anatomy.Root, { ...props, children: children });
};
export const ContextMenuIcon = Anatomy.Icon;
export const ContextMenuTrigger = Anatomy.Trigger;
export const ContextMenuPortal = Anatomy.Portal;
export const ContextMenuContent = Anatomy.Content;
export const ContextMenuItem = Anatomy.Item;
export const ContextMenuGroup = Anatomy.ItemGroup;
export const ContextMenuShortcut = Anatomy.Shortcut;
export const ContextMenuLabel = Anatomy.GroupLabel;
export const ContextMenuCheckboxItem = Anatomy.CheckboxItem;
export const ContextMenuRadioGroup = Anatomy.RadioGroup;
export const ContextMenuRadioItem = Anatomy.RadioItem;
export const ContextMenuItemIndicator = Anatomy.ItemIndicator;
export const ContextMenuSeparator = Anatomy.Separator;
export const ContextMenuSubMenu = Anatomy.SubMenu;
export const ContextMenuSubTrigger = Anatomy.SubTrigger;
export const ContextMenuSubContent = Anatomy.SubContent;
